import * as React from "react";
const SvgIconArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 7, viewBox: "0 0 12 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0L6 3.88889L12 0V3.11111L6 7L0 3.11111V0Z", fill: "#646464" }));
export default SvgIconArrowDown;
